export default [
    {
        name: 'SIT',
        label: 'Situação'
    },
    {
        name: 'CD_FIL',
        label: 'Filial'
    },
    {
        name: 'NR_PC',
        label: 'Nº ped.'
    },
    {
        name: 'CD_NUM',
        label: 'Cód. num.'
    },
    {
        name: 'CD_ALFA',
        label: 'Alfa'
    },
    {
        name: 'NM_PROD',
        label: 'N. Prod.'
    },
    {
        name: 'AB_COR1',
        label: 'Cor'
    },
    {
        name: 'QTD',
        label: 'Qtd'
    },
];